<template>
    <div class="reminders-side-form">
        <div class="reminders-widget-header">
            <i class="icon icon-bell"></i>

            <h2>{{ $t('Напоминания') }}</h2>

            <div>
                <i class="icon icon-times"></i>
            </div>
        </div>
        <div class="reminders-widget-container">
            <ReminderWidgetItem :reminder="reminder" v-for="reminder in reminders.actual" :key="reminder.id" />
        </div>

        <MobilePlusBtn type="new-reminder" />
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import MobilePlusBtn from "@/new/components/MobilePlusBtn.vue";
import ReminderWidgetItem from "@/new/components/Reminders/ReminderWidgetItem.vue";

export default {
    name: "RemindersSideForm",

    components: {
        ReminderWidgetItem,
        MobilePlusBtn
    },

    mounted() {
        this.loadCategories();
        this.loadReminders();
    },

    computed: {
        ...mapGetters(['categories', 'reminders', 'isRemindersLoaded']),
    },

    methods: {
        ...mapActions(['loadCategories', 'loadReminders', ]),
    }
}
</script>

<style scoped lang="scss">
.reminders-side-form {
    background: #fff;
    border-radius: 5px;
    height: 100%;
    margin-top: -6px;

    .reminders-widget-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 16px;
        padding: 0 24px 24px;

        h2 {
            margin: 0;

            font-size: 18px;
            font-family: 'Proxima Nova Lt';
            font-weight: 600;

            color: #152640;
        }

        .icon-times {
            opacity: 0;
        }
    }

    .reminders-widget-container {
        border-top: 1px solid rgba(#152640, .1);
        padding: 0 24px;

        .reminder-item:first-child {
            border-top: 0;
        }
    }
}
</style>